import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lancasterCaConfig } from "./data";

export default function LancasterCaPage() {
  return <CityPageTemplate config={lancasterCaConfig} />;
}